export const normalizeAutocompleteText = (value) => String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ")

export const normalizeCompanySearch = (value) => {
    const raw = String(value ?? "").trim()
    const text = normalizeAutocompleteText(raw)
    const digits = raw.replace(/\D/g, "")
    const hasLetters = /[a-z]/i.test(text)

    return digits && !hasLetters ? digits : text
}

const normalizeTerms = (value, normalizeFilter) => {
    const normalized = normalizeFilter(value)
    const values = Array.isArray(normalized) ? normalized : [normalized]
    return values.map((item) => String(item ?? "").trim()).filter(Boolean)
}

export const filterAutocompleteOptions = (
    options,
    inputValue,
    {
        filterKeys = [],
        getOptionLabel = (option) => String(option ?? ""),
        normalizeFilter = normalizeAutocompleteText,
        minCharsToFilter = 0,
        showAllOptionsOnEmpty = false,
    } = {}
) => {
    const rawInput = String(inputValue ?? "").trim()

    if (!rawInput) return showAllOptionsOnEmpty ? options : []
    if (rawInput.length < minCharsToFilter) return []

    const queryTerms = normalizeTerms(rawInput, normalizeFilter)

    return (options || []).filter((option) => {
        if (!option) return false

        const values = typeof option === "object" && filterKeys.length
            ? [...filterKeys.map((key) => option?.[key]), getOptionLabel(option)]
            : [getOptionLabel(option)]

        const optionTerms = values.flatMap((value) => normalizeTerms(value, normalizeFilter))
        return queryTerms.some((query) => optionTerms.some((term) => term.includes(query)))
    })
}